export const CAMPAIGN_MODALS = '/campaign/modals'
